module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/download-4e79ceea6afed7b679a18444fd7348aa.svg";